import { render, staticRenderFns } from "./AdminPage.vue?vue&type=template&id=044c790e&scoped=true"
import script from "./AdminPage.vue?vue&type=script&lang=js"
export * from "./AdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c790e",
  null
  
)

export default component.exports